import { object, string } from 'yup';

const LOGIN_SCHEMA = object().shape({
  username: string().required('login:required_email'),
  password: string().required('login:required_password'),
});

export default LOGIN_SCHEMA;
